import settings from '@tenant/settings'
import { isObj } from 'lib/util'
import { useMemoRef } from 'platform/react/hook'
import TextFieldGroup from 'ui/Element/Field/Group/Text'
import MaskField from 'ui/Element/Field/Mask'

const { serialFieldConfig } = settings

/**
 * Returns an {@link TextFieldGroup} component if `serialFieldConfig` is either not set in tenant's
 * {@link settings} or an object. Otherwise, returns a {@link MaskField} element. In both cases, all
 * props are passed to the corresponding element.
 *
 * Used to ease transition to the new {@link MaskField} element to be used for serial numbers.
 */
const SerialField = props => (!serialFieldConfig || isObj(serialFieldConfig)
  ? <MaskField {...props} />
  : <TextFieldGroup {...props} />)

export default useMemoRef(SerialField, false)
